/**
 * Tooltip copy for the area-management affordances, which are visible but not
 * yet shipped. Each string names the action its own button offers.
 */

export const ADD_OR_REMOVE_AREAS_COMING_SOON =
  "Adding and removing areas is coming soon.";
